import React from 'react';
import { Bar } from 'react-chartjs-2'
import 'chart.js/auto'

const BarChart = ({ data, options, id, backgroundColor }) => {
    return <div style={{ backgroundColor: backgroundColor, border: 'none' }} id={id}><Bar data={data} options={options} /></div>;
};

export default BarChart;